import { Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const Remplacement = () => {
  const { dataCreateMission, setDataCreateMission, language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`missionCreation.motifForm.${key}`, fallback);
  const { toggle } = useModal();

  // Every field falls back to '' so the inputs stay controlled even when the
  // saved motif misses one.
  const [infos, setInfos] = useState(() => {
    const savedMotif =
      dataCreateMission?.motif?.type === '3' ? dataCreateMission.motif : {};
    return {
      type: '3',
      name: savedMotif.name ?? '',
      prenom: savedMotif.prenom ?? '',
      poste: savedMotif.poste ?? '',
      message: savedMotif.message ?? '',
    };
  });
  const [lengthMessage, setLengthMessage] = useState(false);
  const [validMessage, setValidMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorName, setErrorName] = useState(false);
  const [errorPrenom, setErrorPrenom] = useState(false);
  const [errorPoste, setErrorPoste] = useState(false);

  const verif = infos.message.length;

  useEffect(() => {
    if (verif <= 8) {
      setErrorMessage(true);
      setLengthMessage(false);
    } else {
      setErrorMessage(false);
      setLengthMessage(true);
    }
  }, [infos.message, verif]);

  const handleChange = (field) => (e) => {
    const { value } = e.target;
    setInfos((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    // Validation
    const errs = {
      name: infos.name === '',
      prenom: infos.prenom === '',
      poste: infos.poste === '',
      message: infos.message.length <= 8,
    };
    setErrorName(errs.name);
    setErrorPrenom(errs.prenom);
    setErrorPoste(errs.poste);
    setErrorMessage(errs.message);

    if (!errs.name && !errs.prenom && !errs.poste && !errs.message) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: infos,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {text('titles.replacement', 'Remplacement d’un salarié absent')}
      </Modalheader>
      <ModalBody>
        <div className="grid grid-cols-2 gap-8">
          <div className="flex flex-col gap-1.5">
            <StyledInput
              type={'text'}
              label={text('name', 'Nom')}
              value={infos.name}
              onChange={handleChange('name')}
            />
            {errorName && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('nameRequired', 'Veuillez indiquer un nom')}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-1.5">
            <StyledInput
              type={'text'}
              label={text('firstname', 'Prénom')}
              value={infos.prenom}
              onChange={handleChange('prenom')}
            />
            {errorPrenom && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('firstnameRequired', 'Veuillez indiquer un prénom')}
              </p>
            )}
          </div>
          <div className="col-span-2 flex flex-col gap-1.5">
            <StyledInput
              type={'text'}
              label={text('replacedPosition', 'Poste remplacé')}
              value={infos.poste}
              onChange={handleChange('poste')}
            />
            {errorPoste && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('positionRequired', 'Veuillez indiquer un poste')}
              </p>
            )}
          </div>
        </div>
        <div className="mt-5 flex flex-col">
          <StyledInput
            type={'textarea'}
            label={text(
              'absenceDescription',
              'Décrivez précisément le motif de l’absence de votre salarié.',
            )}
            value={infos.message}
            maxLength={250}
            hint={text('maxLengthHint', '250 caractères')}
            onChange={handleChange('message')}
          />
        </div>
        {errorMessage && (
          <p className="text-yellow-400 flex items-center gap-4">
            <Information wh={16} color={'#FFA43D'} />
            {text(
              'lengthError',
              'Veuillez faire un message de plus de 10 caractères',
            )}
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          {text('cancel', 'Annuler')}
        </Button>
        <Button
          size={'LG'}
          onClick={handleSubmit}
          disabled={!lengthMessage || errorName || errorPrenom || errorPoste}
        >
          {text('confirm', 'Confirmer')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default Remplacement;
